import { render } from "./Setting.vue?vue&type=template&id=7b4e2ed4&scoped=true"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"

import "./Setting.vue?vue&type=style&index=0&id=7b4e2ed4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b4e2ed4"],['__file',"src/components/Budget/Setting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b4e2ed4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b4e2ed4', __exports__)) {
    api.reload('7b4e2ed4', __exports__)
  }
  
  module.hot.accept("./Setting.vue?vue&type=template&id=7b4e2ed4&scoped=true", () => {
    api.rerender('7b4e2ed4', render)
  })

}


export default __exports__